export enum NavLinkText {
  OrderInsights = 'Order Insights',
  FileInfo = 'File Info',
  BackTitle = 'Back Title',
  CPL = 'CPL',
  ServiceOrders = 'Service Orders',
  Underwriting = 'Underwriting',
  Jackets = 'Jackets',
  RatesFees = 'Rates & Fees',
  Documents = 'Documents',
  ReportPay = 'Report & Pay',
  ServiceOrderInvoices = 'Service Order Invoices',
  Statements = 'Statements',
  AgencyVerificationLetters = 'Agency Verification Letters',
  BackTitleSearch = 'Back Title Search',
  PropertyReports = 'Property Reports',
  PolicyUpload = 'Policy Upload',
  FraudPrevention = 'Fraud Prevention',
  SDNSearch = 'SDN Search',
  Reports = 'Reports',
  UserProfilePreferences = 'User Profile & Preferences',
  AddressBook = 'Address Book',
  Billing = 'Billing',
  PaymentMethods = 'Payment Methods',
  AutopayServices = 'Autopay Services',
  AutoReporting = 'Auto-Reporting',
  ESignatures = 'e-Signatures',
  Users = 'Users',
  AddOns = 'Add-Ons',
  FinCenRealEstateReport = 'FinCEN Real Estate Report',
  FilingInformation = 'Filing Information',
  ReportingPartyInformation = 'Reporting Party Information',
  PropertyInformation = 'Property Information',
  TransfereeInformation = 'Transferee Information',
  TransferorInformation = 'Transferor Information',
  PaymentInformation = 'Payment Information',
  CertifyGenerateReport = 'Certify & Generate Report',
  Summary = 'Summary',
  AllOrders = 'All Orders',
  FilesInProcess = 'Files In Process',
  Invoices = 'Invoices',
  Upload = 'Upload',
  History = 'History',
  PartyVerification = 'Party Verification',
  WireVerification = 'Wire Validation',
  ManageUsers = 'Manage Users',
  PreferredOffices = 'Preferred Offices',
  Profile = 'Profile',
  Review = 'Review',
  Report = 'Report',
  Pay = 'Pay',
  ViewInvoices = 'View Invoices',
  OrderManagementDashboard = 'Order Management Dashboard',
  InventoryManagement = 'Inventory Management',
  PolicyNumberManagement = 'Policy Number Management',
  FormManagement = 'Form Management',
  OracleDowntimeSchedule = 'Upcoming Oracle Downtime',
}
